// src/pages/IdentifiantPage.js
import React from 'react';
import { motion } from 'framer-motion';
import LogoBar from '../components/Logobar';
import IdentifiantForm from '../components/Identifiant';
import Footer from '../components/Footer';
import '../components/Identifiant.css';

const fadeUp = {
  initial: { opacity: 0, y: 40 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.72, ease: [0.65, 0.05, 0.36, 1] }
};

const IdentifiantPage = () => {
  const handleCoincoverClick = () => {
    window.open('https://www.coincover.com/', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="identifiant-page-container">
      {/* BARRE DE NAVIGATION */}
      <motion.div 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.65, 0.05, 0.36, 1] }}
      >
        <LogoBar />
      </motion.div>

      {/* HERO NOIR */}
      <motion.section 
        className="identifiant-hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.1 }}
      >
        <div className="hero-content">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
          >
            Une méthode de chiffrement de pointe
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.35 }}
          >
            Restez serein, quoi qu'il arrive. <br />
            Récupérez votre wallet sans effort, même en cas de perte de vos informations.
          </motion.p>
        </div>
      </motion.section>

      {/* FORMULAIRE + GIF */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.5 }}
      >
        <IdentifiantForm />
      </motion.div>

      {/* BOUTON COINCOVER */}
      <motion.div 
        style={{ textAlign: 'center', padding: '1rem 0' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.7 }}
      >
        <button
          className="coincover-button"
          onClick={handleCoincoverClick}
        >
          <span>🔒</span> Service fourni par Coincover
        </button>
      </motion.div>

      {/* SÉPARATEUR */}
      <motion.div
        initial={{ opacity: 0, scaleX: 0 }}
        animate={{ opacity: 1, scaleX: 1 }}
        transition={{ duration: 0.8, delay: 0.8 }}
      >
        <div className="activation-separator" />
      </motion.div>

      {/* FOOTER */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.9 }}
      >
        <Footer />
      </motion.div>
    </div>
  );
};

export default IdentifiantPage;